<template>
  <v-layout wrap>
    <v-flex
      xs12
      md3
    >
      <v-text-field
        v-model="currentUser.id"
        label="User ID"
        disabled
      />
    </v-flex>
    <v-flex
      xs12
      md9
    >
      <v-text-field
        v-model="currentUser.email"
        label="Email"
        disabled
      />
    </v-flex>

    <v-flex md6>
      <v-text-field
        v-model="formData.firstName"
        label="First name"
        :error-messages="getFieldErrors('firstName')"
        @change="$v.formData.firstName.$touch()"
        @blur="$v.formData.firstName.$touch()"
      />
    </v-flex>
    <v-flex md6>
      <v-text-field
        v-model="formData.lastName"
        label="Last name"
        :error-messages="getFieldErrors('lastName')"
        @change="$v.formData.lastName.$touch()"
        @blur="$v.formData.lastName.$touch()"
      />
    </v-flex>
    <v-flex md3>
      <v-menu
        v-model="pickerBirthDateOpen"
        :close-on-content-click="false"
        full-width
        max-width="290"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="formData.birthDate"
            label="Birth date"
            prepend-icon="event"
            readonly
            :error-messages="getFieldErrors('birthDate')"
            v-on="on"
            @change="$v.formData.birthDate.$touch()"
            @blur="$v.formData.birthDate.$touch()"
          />
        </template>
        <v-date-picker
          v-model="formData.birthDate"
          :max="todaysDate"
          show-current
          color="info"
          @change="pickerBirthDateOpen = false"
        />
      </v-menu>
    </v-flex>
    <v-flex md4>
      <v-text-field
        v-model="formData.birthPlace"
        label="Place of birth"
        :error-messages="getFieldErrors('birthPlace')"
        @change="$v.formData.birthPlace.$touch()"
        @blur="$v.formData.birthPlace.$touch()"
      />
    </v-flex>
    <v-flex xs5>
      <v-autocomplete
        v-model="formData.nationality"
        :items="countryCodesArray"
        :search-input.sync="countrySearch"
        item-text="name"
        item-value="backendValue"
        label="Country"
        :error-messages="getFieldErrors('nationality')"
        @change="$v.formData.nationality.$touch()"
        @blur="$v.formData.nationality.$touch()"
      />
    </v-flex>
    <v-flex
      xs12
      md7
    >
      <v-text-field
        v-model="formData.streetAddress"
        label="Address"
        :error-messages="getFieldErrors('streetAddress')"
        @change="$v.formData.streetAddress.$touch()"
        @blur="$v.formData.streetAddress.$touch()"
      />
    </v-flex>
    <v-flex
      md3
      xs6
    >
      <v-text-field
        v-model="formData.city"
        label="City"
        :error-messages="getFieldErrors('city')"
        @change="$v.formData.city.$touch()"
        @blur="$v.formData.city.$touch()"
      />
    </v-flex>
    <v-flex
      md2
      xs6
    >
      <v-text-field
        v-model="formData.postalCode"
        label="Postal code"
        :error-messages="getFieldErrors('postalCode')"
        @change="$v.formData.postalCode.$touch()"
        @blur="$v.formData.postalCode.$touch()"
      />
    </v-flex>
    <v-flex
      xs12
      md3
    >
      <v-select
        v-model="formData.identDocumentType"
        :items="docTypes"
        item-text="title"
        item-value="value"
        label="Legitimation document"
        :error-messages="getFieldErrors('identDocumentType')"
        @change="$v.formData.identDocumentType.$touch()"
        @blur="$v.formData.identDocumentType.$touch()"
      />
    </v-flex>
    <v-flex
      xs12
      md5
    >
      <v-text-field
        v-model="formData.authority"
        label="Issuer / Authority"
        :error-messages="getFieldErrors('authority')"
        @change="$v.formData.authority.$touch()"
        @blur="$v.formData.authority.$touch()"
      />
    </v-flex>
    <v-flex xs4>
      <v-autocomplete
        v-model="formData.countryOfDocument"
        :items="countryCodesArray"
        :search-input.sync="DocumentCountrySearch"
        item-text="name"
        item-value="value"
        label="Document Country"
        :error-messages="getFieldErrors('countryOfDocument')"
        @change="$v.formData.countryOfDocument.$touch()"
        @blur="$v.formData.countryOfDocument.$touch()"
      />
    </v-flex>
    <v-flex
      xs12
      md3
    >
      <v-menu
        :close-on-content-click="true"
        full-width
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="fileName"
            readonly
            label="Attach document"
            prepend-icon="attach_file"
            :error-messages="getFieldErrors('file')"
            v-on="on"
            @click="$refs.fileInput.click()"
          />
        </template>
        <input
          ref="fileInput"
          type="file"
          accept="application/pdf"
          style="display:none"
          @input="onFileChange"
        >
      </v-menu>
    </v-flex>

    <v-flex
      sm3
      md3
    >
      <v-text-field
        v-model="formData.legitimationDocumentNumber"
        label="Document number"
        :error-messages="getFieldErrors('legitimationDocumentNumber')"
        @input="$v.formData.legitimationDocumentNumber.$touch()"
        @blur="$v.formData.legitimationDocumentNumber.$touch()"
      />
    </v-flex>

    <v-flex md3>
      <v-menu
        v-model="pickerDocIssueDateOpen"
        :close-on-content-click="false"
        full-width
        max-width="290"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="formData.legitimationDocumentCreatedAt"
            label="Document issued at"
            prepend-icon="event"
            readonly
            :error-messages="getFieldErrors('legitimationDocumentCreatedAt')"
            v-on="on"
            @change="$v.formData.legitimationDocumentCreatedAt.$touch()"
            @blur="$v.formData.legitimationDocumentCreatedAt.$touch()"
          />
        </template>
        <v-date-picker
          v-model="formData.legitimationDocumentCreatedAt"
          :max="todaysDate"
          show-current
          color="info"
          @change="pickerDocIssueDateOpen = false"
        />
      </v-menu>
    </v-flex>

    <v-flex md3>
      <v-menu
        v-model="pickerDocExpiryDateOpen"
        :close-on-content-click="false"
        full-width
        max-width="290"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="formData.legitimationDocumentExpiresAt"
            label="Document expires at"
            prepend-icon="event"
            readonly
            :error-messages="getFieldErrors('legitimationDocumentExpiresAt')"
            v-on="on"
            @change="$v.formData.legitimationDocumentExpiresAt.$touch()"
            @blur="$v.formData.legitimationDocumentExpiresAt.$touch()"
          />
        </template>
        <v-date-picker
          v-model="formData.legitimationDocumentExpiresAt"
          :min="todaysDate"
          show-current
          color="info"
          @change="pickerDocExpiryDateOpen = false"
        />
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { legitimationDocTypes } from '@/enum/ident/IdentEnum';
import { countryCodesArray } from '@/enum/CountryCodesEnum';
import { getBase64FileContent } from '@/helpers';

const fileSizeLimit = 5;

function fileMaxSize(val) {
  return !val || val.size < fileSizeLimit * 1024 * 1024;
}

export default {
  name: 'ExporoIdentFormFields',
  props: {
    currentUser: {
      type: Object,
      default: null,
      required,
    },
    onSubmit: {
      type: Function,
      required,
      default: null,
    },
  },

  data: () => ({
    countryCodesArray,
    legitimationDocTypes,
    countrySearch: '',
    DocumentCountrySearch: '',
    pickerBirthDateOpen: false,
    pickerDocIssueDateOpen: false,
    pickerDocExpiryDateOpen: false,
    error: null,
    todaysDate: new Date().toISOString().substr(0, 10),
    formData: {
      provider: 'Exporo',
      lastName: null,
      firstName: null,
      birthDate: null,
      birthPlace: null,
      nationality: null,
      streetAddress: null,
      city: null,
      postalCode: null,
      identDocumentType: null,
      legitimationDocumentNumber: null,
      legitimationDocumentCreatedAt: null,
      legitimationDocumentExpiresAt: null,
      authority: null,
      countryOfDocument: null,
      file: null,
    },
  }),

  validations() {
    return {
      formData: {
        provider: { required }, // "Exporo"
        lastName: { required }, // "Doe"
        firstName: { required }, // "John",
        streetAddress: { required }, // "Strasse",
        city: { required }, // "Hamburg",
        postalCode: { required }, // "1234",
        identDocumentType: { required }, //  "pass",
        legitimationDocumentNumber: { required }, // "1234",
        birthDate: { required }, //  "2000-01-31",
        birthPlace: { required }, //  "Berlin",
        nationality: { required }, //  "DE",
        authority: { required }, //  "mayor of Hamburg",
        countryOfDocument: { required }, //  "DE",
        legitimationDocumentCreatedAt: { required }, //  "2000-02-28",
        legitimationDocumentExpiresAt: { required }, //  "2000-02-28",
        file: { required, fileMaxSize }, // "base64",
      },
    };
  },
  computed: {
    validFields() {
      return Object.keys(this.$v.formData.$params).filter(
        item => !this.$v.formData[item].$invalid,
      );
    },
    errors() {
      return Object.keys(this.$v.formData.$params).filter(
        item => this.$v.formData[item].$invalid,
      );
    },
    fileName() {
      return this.formData.file ? this.formData.file.name : null;
    },
    docTypes() {
      return Object.keys(this.legitimationDocTypes).map(
        value => this.legitimationDocTypes[value],
      );
    },
  },
  watch: {
    currentUser(user) {
      if (user) {
        return this.mapUserData();
      }

      return this.resetUserData();
    },
  },
  mounted() {
    this.mapUserData();
  },
  methods: {
    getFieldErrors(field) {
      const errors = [];
      if (this.$v.formData[field]) {
        if (!this.$v.formData[field].$dirty || !this.$v.formData[field].$invalid) {
          return errors;
        }

        if (!this.$v.formData[field].required) {
          errors.push('Required field');
        }
        if (!this.$v.formData[field].fileMaxSize) {
          errors.push(`File is too big. Max size is ${fileSizeLimit}MB.`);
        }
      }

      return errors;
    },
    mapUserData() {
      // POST IDENT / IDNOW FORM DATA
      this.formData.userId = this.currentUser.id;
      this.formData.firstName = this.currentUser.first_name;
      this.formData.lastName = this.currentUser.last_name;
      this.formData.streetAddress = this.currentUser.address;
      this.formData.city = this.currentUser.city;
      this.formData.postalCode = this.currentUser.postal_code;

      // check currentUser.country and try to match a valid country
      const country = this.countryCodesArray
        // eslint-disable-next-line max-len
        .find(
          item => item.backendValue ===
            (this.currentUser.country ||
              this.currentUser.citizenship ||
              this.currentUser.country_of_birth),
        );
      this.formData.nationality = country ? country.backendValue : null;
    },
    resetUserData() {
      this.formData.userId = null;
      this.formData.firstName = null;
      this.formData.lastName = null;
      this.formData.streetAddress = null;
      this.formData.city = null;
      this.formData.country = null;
      this.formData.postalCode = null;
      this.formData.identDocumentType = null;
      this.formData.legitimationDocumentNumber = null;
      this.formData.birthDate = null;
      this.formData.birthPlace = null;
      this.formData.nationality = null;
      this.formData.authority = null;
      this.formData.countryOfDocument = null;
      this.formData.legitimationDocumentCreatedAt = null;
      this.formData.legitimationDocumentExpiresAt = null;
      this.formData.file = null;
    },

    async onFileChange(e) {
      const [file] = e.target.files;
      if (!file) {
        this.formData.file = null;
        this.$v.formData.file.$touch();
      } else {
        try {
          const { content, prefix } = await getBase64FileContent(file);
          const { name, type, size } = file;
          const ext = name.substring(name.lastIndexOf('.') + 1);

          this.formData.file = {
            name,
            ext,
            type,
            content,
            prefix,
            size,
          };
          this.$v.formData.file.$touch();
        } catch (err) {
          this.formData.file = null;
          this.$v.formData.file.$touch();
          console.error(err);
        }
      }
    },

    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.onSubmit(this.formData);
      }
    },
  },
};
</script>

<style lang="scss" >
</style>



// WEBPACK FOOTER //
// src/components/ident/dialog/create/ExporoIdentFormFields.vue